import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import moment from 'moment'
import {formatPrice} from '../helpers/helpers'
import ReactTable from 'react-table'
import "react-table/react-table.css";

import Sidebar from './inc/Sidebar';
import PrintSales from './PrintSales';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';

import ReportsCustomDisplay from './ReportsCustomDisplay'


class ReportsSales extends Component {

    constructor(){
        super();
        this.print = this.print.bind(this)
        this.select = this.select.bind(this)
        this.range = this.range.bind(this)
        this.state = {
            user :{},
            quotation: {},
            queryQuotation: {},
            userId :{},
            display : "togglehide",
            select : "All",
            fromDate : "",
            toDate : ""
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId : data.key,
                        user:data.val()
                      })


                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        }); 

        let quotationDeal = ref.child("Quotation").orderByChild("status").equalTo("Deal");
            quotationDeal.on("value", function(snap){
                this.setState({
                    quotation : snap.val(),
                    queryQuotation : snap.val()
                })
            }.bind(this))

    }
    select(e){
        e.preventDefault();
        console.log(this.option.value)
        var temp=[];

        if(this.option.value === "Custom"){
            this.setState({
                quotation : {},
                display : "toggleshow",
                select : this.option.value

            })
        }

        if(this.option.value === "Daily"){
            Object.keys(this.state.queryQuotation).map(key => {
                
                let list = this.state.queryQuotation[key] 
                let listDate = moment(list.quoteDate).format("MM DD YYYY")
                let nowDate = moment().format("MM DD YYYY") 
                
                if(moment(nowDate).isSame(listDate,'days')){
                    let price = list.totalQuote
                    list.formattedTotalQuote = formatPrice(price)
                    list.quoteDate = moment(list.quoteDate).format("MM DD YYYY")
                    temp.push(list)
                }           
            })
            this.setState({
                quotation : temp,
                display : "togglehide",
                select : this.option.value
            }) 
        }

        if(this.option.value === "All"){
            Object.keys(this.state.queryQuotation).map(key => {
                let list = this.state.queryQuotation[key] 
                    temp.push(list)
            })
            this.setState({
                quotation : temp,
                display : "togglehide",
                select : this.option.value
            }) 
        }

        if(this.option.value === "Weekly"){
            Object.keys(this.state.queryQuotation).map(key => {
                
                let list = this.state.queryQuotation[key]
                let listDate = moment(list.quoteDate).format("MM DD YYYY")
                let nowDate = moment().format("MM DD YYYY") 
                if(moment(nowDate).isSame(listDate,'week')){
                    let price = list.totalQuote
                    list.formattedTotalQuote = formatPrice(price)
                    list.quoteDate = moment(list.quoteDate).format("MM DD YYYY")
                    temp.push(list)   
                  
                }           
            })
            this.setState({
                quotation : temp,
                display : "togglehide",
                select : this.option.value
            }) 
        }

        if(this.option.value === "Monthly"){
            Object.keys(this.state.queryQuotation).map(key => {
                
                let list = this.state.queryQuotation[key]
                let listDate = moment(list.quoteDate).format("MM DD YYYY")
                let nowDate = moment().format("MM DD YYYY") 
                if(moment(nowDate).isSame(listDate,'month')){
                    let price = list.totalQuote
                    list.formattedTotalQuote = formatPrice(price)
                    list.quoteDate = moment(list.quoteDate).format("MM DD YYYY")
                    temp.push(list)   
                  
                }           
            })
            this.setState({
                quotation : temp,
                display :"togglehide",
                select : this.option.value
            }) 
        }
    }

    print(){
        window.print();
    }

    range(e){
        e.preventDefault();
        if(this.daterange1.value && this.daterange2.value){
            let temp = []; 
            this.state.queryQuotation &&
            Object.keys(this.state.queryQuotation).map(key => {
                let list = this.state.queryQuotation[key] 
                let quoteDate = moment(list.quoteDate).format("MM DD YYYY") 
                let daterange1 = moment(this.daterange1.value).format("MM DD YYYY") 
                let daterange2 = moment(this.daterange2.value).format("MM DD YYYY")                                                                                        
                    if(moment(quoteDate).isBetween(daterange1,daterange2,'days',[])){                        
                        temp.push(list)                        
                    } 
            }) 
            this.setState({
                quotation : temp,
                fromDate : moment(this.daterange1.value).format("MM DD YYYY"),
                toDate : moment(this.daterange2.value).format("MM DD YYYY")
            })
        }else{
            alert("No date specified")
        }

        this.formRange.reset();
       
    }

    componentDidUpdate(prevProps,prevState){
        if(prevState.quotation!==this.state.quotation){
            
            this.setState({
                quotation : this.state.quotation
            })
        }

        if(prevState.display!==this.state.display){
            
            this.setState({
                display : this.state.display
            })

        }

    }

    

    render() {
        
        var x =[];
        if (x.length === 0){
            this.state.quotation &&
            Object.keys(this.state.quotation).map(key => {
                let list = this.state.quotation[key]
                let price = list.totalMaterials
                list.formattedTotalMaterials = formatPrice(price)
                list.quoteDate = moment(list.quoteDate).format("MM/DD/YYYY")
                list.customer.name = list.customer.name.toUpperCase();
                list.customer.location = list.customer.location.toUpperCase();
                list.customer.representative = list.customer.representative.toUpperCase();
                x.push(list) 
                       
            }) 
        }
         
         
        
        return (
            <div>
                <div id="page-wrapper" className="no-print">
                    <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                        <Sidebar  role={this.state.user.role} />
                        <div id="main-container">
                            <Header />
                            <div id="page-content">
                                <Title title="Sales Reports" />

                                <div className="selectCustomeWrapper">
                                    <div className="form-group">
                                        <form onSubmit={this.select}>
                                        <select className="select-chosen" ref={(input)=>{this.option=input}} >
                                            <option>All</option>
                                            <option>Daily</option>
                                            <option>Weekly</option>
                                            <option>Monthly</option>
                                            <option>Custom</option>                                   
                                        </select>
                                        <button type="submit" className="btn btn-sm btn-primary inventorySubmit"><i className="fa fa-angle-right"></i> Submit</button>
                                        <button type="button" className="btn btn-sm btn-primary pull-right inventoryPrint" onClick={this.print}><i className="fa fa-print"></i> Print</button>
                                        </form>
                                       
                                    </div><div className="clearfix"></div>
                                </div>
                                <div className="block">
                                    <div id="customForm" className={`${this.state.display}`}>
                                        <form  className="form-horizontal form-bordered" ref={(input) => {this.formRange=input}} onSubmit={this.range}>
                                            <fieldset>
                                                <div className="form-group">
                                                    <label className="col-md-4 control-label" htmlFor="example-daterange1">Select Date Range</label>
                                                    <div className="col-md-8">
                                                        <div className="input-group input-daterange" data-date-format="mm/dd/yyyy">
                                                            <input type="text" id="example-daterange1" name="daterange1" ref={(input)=>this.daterange1 = input} className="form-control text-center" placeholder="From" />
                                                            <span className="input-group-addon"><i className="fa fa-angle-right"></i></span>
                                                            <input type="text" id="example-daterange2" name="daterange2" ref={(input)=>this.daterange2 = input}className="form-control text-center" placeholder="To" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <div className="form-group form-actions">
                                                <div className="col-md-8 col-md-offset-4">
                                                    <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-angle-right"></i> Submit</button>
                                                    <button type="reset" className="btn btn-sm btn-warning"><i className="fa fa-repeat"></i> Reset</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div>
                                        <ReactTable
                                            data={x}
                                            columns={[
                                                {
                                                    Header: "Quotation Number",
                                                    accessor : "quoteNumber"
                                                },
                                                {
                                                    Header: "Date",
                                                    accessor : "quoteDate"
                                                },
                                                {
                                                    Header: "Customer Name",
                                                    accessor : "customer.name",
                                                    filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                                },
                                                {
                                                    Header: "Address",
                                                    accessor : "customer.location",
                                                    filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                                },
                                                {
                                                    Header: "Sales Representative",
                                                    accessor : "customer.representative",
                                                    filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                                    Footer :(
                                                        <div className="forTotalReport">
                                                        <span>
                                                            <strong>Total:</strong>
                                                        </span>
                                                        </div>
                                                        )

                                                },
                                                {
                                                    Header: 'Total Quotation',
                                                    accessor : "formattedTotalMaterials",
                                                    Footer :(
                                                            <div className="forTotalReport">
                                                            <span>
                                                                { 
                                                                    formatPrice(Object.keys(x)
                                                                        .reduce( function( sum, key){
                                                                        return sum + parseFloat( x[key].totalMaterials );                                                        
                                                                        }, 0 )
                                                                    )

                                                                }
                                                            </span>
                                                            </div>
                                                            )
                                                }
                                            ]}
                                            
                                            filterable ={true}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />                                
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
                <PrintSales selected={this.state.select} data={x} fromDate={this.state.fromDate} toDate={this.state.toDate}/>
            </div>
      
        );
    }
}

export default ReportsSales;



// WEBPACK FOOTER //
// ./src/components/ReportsSales.js